import * as types from '../../mutation-types'
import lazyLoading from './lazyLoading'
import taskmanage from './taskmanage'
import contentLabel from './contentlabel'
import quality from './qualityManage'

let localPerms = []
try {
    localPerms = JSON.parse(localStorage.getItem('qu_local_perms')) || []
} catch (err) {}

let items = [
    {
        name: 'auth',
        path: 'Login',
        meta: {
            icon: 'fa-tachometer',
            label: '登陆',
            nomenu: true
        },
        component: lazyLoading('auth/WxLogin')
    },
    taskmanage,
    contentLabel,
    quality
    // statistic
]

authNomenu(items, localPerms)

const state = {
    items: items
}

const mutations = {
    [types.EXPAND_MENU](state, menuItem) {
        if (menuItem.index > -1) {
            if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
                state.items[menuItem.index].meta.expanded = menuItem.expanded
            }
        } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
            menuItem.item.meta.expanded = menuItem.expanded
        }
    },

    [types.TOGGLE_NO_MENU](state, { menuItem, nomenu }) {
        menuItem.meta.nomenu = nomenu
    }
}

function authNomenu(menu, perms = []) {
    // menu: 菜单列表，perm：权限列表
    menu.forEach(menuItem => {
        let { meta = {} } = menuItem
        let { auth = {} } = meta

        if (!meta.nomenu && auth.needApis) {
            auth.needApis.forEach(api => {
                let no = true // 默认不显示
                for (let i = 0, len = perms.length; i < len; i++) {
                    // 遍历权限列表
                    let p = perms[i]
                    if (p.project === api.project && p.uri === api.path) {
                        if (!p.has) {
                            // has不为1 时，不显示，结束遍历
                            no = true
                            break
                        } else {
                            // has为1时，显示
                            no = false
                        }
                    }
                }
                menuItem.meta.nomenu = no
            })
        }
        if (menuItem.children) {
            authNomenu(menuItem.children, perms)
        }
    })
    return menu
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js